import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { useHomePageValuationLookup } from '../../../features/landing/HomePageValuationLookup/HomePageValuationLookup.hook';
import {
  valuationSchema,
  type ValuationFormValues,
} from '../../../components/CarValuationPage/components/ValuationTool/ValuationTool.schema';
import { ValuationLookupForm } from '../../../features/landing/HomePageValuationLookup/ValuationLookupForm/ValuationLookupForm';
import { MILEAGE_UNIT } from '../../../types';

const HomePageValuationLookup = () => {
  const { onSubmit } = useHomePageValuationLookup();

  const methods = useForm<ValuationFormValues>({
    resolver: zodResolver(valuationSchema),
    defaultValues: {
      registration: '',
      mileage: '',
      mileageType: MILEAGE_UNIT.KILOMETRES,
    },
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} noValidate>
        <ValuationLookupForm />
      </form>
    </FormProvider>
  );
};

export { HomePageValuationLookup };
